import React, { useEffect } from "react";
import { useCountries } from "../../../../hooks/shared/use-countries";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { NODE_NAMES } from "../../../../utils/form-builder.types";
import { useFormData } from "../../../../hooks/client/use-form-data";
const FormBuilderFormInterfaceAddress = ({ item, locale, onPending, isPreview, analyticForm, t }) => {
  var _a, _b, _c, _d;
  if (!item) return null;
  const { localizedCountriesList, onCountryChange, updateCountryDetails, countryDetails } = useCountries({
    item,
    locale,
    onPending
  });
  const tags = FormBuilderElementsMappingService.getAllSingleElementHTMLTags(item);
  const legend = tags.legend[0];
  const divs = tags.div;
  const defaultSubdivision = (_a = countryDetails == null ? void 0 : countryDetails.included) == null ? void 0 : _a.find((el) => (el == null ? void 0 : el.type) === "subdivision");
  const codePattern = (_c = (_b = countryDetails == null ? void 0 : countryDetails.data) == null ? void 0 : _b.attributes) == null ? void 0 : _c.postal_code_pattern;
  const { formData, formDataSetters, hostElement } = useFormData();
  const setDefaultSelectsValue = () => {
    var _a2;
    const shadowRoot = (_a2 = hostElement == null ? void 0 : hostElement.querySelector("div")) == null ? void 0 : _a2.shadowRoot;
    for (const select of tags.select) {
      const selectHTML = shadowRoot == null ? void 0 : shadowRoot.getElementById(select.id);
      if (selectHTML) {
        formDataSetters.setInputValue(selectHTML == null ? void 0 : selectHTML.name, selectHTML == null ? void 0 : selectHTML.value);
      }
    }
  };
  useEffect(() => {
    var _a2;
    onCountryChange({ localizeCountryNames: true });
    if (isPreview && localizedCountriesList.length) {
      const defaultCountry = (_a2 = localizedCountriesList == null ? void 0 : localizedCountriesList[0]) == null ? void 0 : _a2.value;
      updateCountryDetails(defaultCountry);
    }
    setDefaultSelectsValue();
  }, [isPreview, (_d = countryDetails == null ? void 0 : countryDetails.subdivisionsList) == null ? void 0 : _d.length]);
  const onFocus = (e, input) => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(input.name);
  };
  const onBlur = (input) => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(input.name);
  const renderSelectElement = (element, label, isStateInput, previewList) => {
    const list = isStateInput ? countryDetails == null ? void 0 : countryDetails.subdivisionsList : localizedCountriesList;
    const defaultValue = formData == null ? void 0 : formData[element.name];
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { htmlFor: label.for }, t(label.nodeValue)), /* @__PURE__ */ React.createElement(
      "select",
      {
        onChange: isStateInput ? null : (e) => onCountryChange({ e }),
        onFocus: (e) => onFocus(e, element),
        onBlur: () => onBlur(element),
        name: element.name,
        id: element.id,
        autoComplete: element.autocomplete,
        defaultValue,
        required: element.required
      },
      (isPreview ? previewList : list).map((option, index) => {
        return /* @__PURE__ */ React.createElement("option", { key: `${option.value}-${index}`, value: option.value, id: option.value }, option.name);
      })
    ));
  };
  return /* @__PURE__ */ React.createElement("fieldset", { className: item.class }, /* @__PURE__ */ React.createElement("legend", null, t(legend.nodeValue)), divs.map((div, index) => {
    var _a2, _b2, _c2, _d2, _e;
    const tags2 = FormBuilderElementsMappingService.getSingleElementHTMLTags(div);
    const label = tags2.label;
    const element = tags2.input || tags2.select;
    const isPostalCodeInput = element.autocomplete.includes("postal-code");
    const isStateInput = element.autocomplete.includes("address-level1");
    const previewList = isStateInput ? [{ value: defaultSubdivision == null ? void 0 : defaultSubdivision.id, name: (_a2 = defaultSubdivision == null ? void 0 : defaultSubdivision.attributes) == null ? void 0 : _a2.name }] : [{ value: (_b2 = countryDetails == null ? void 0 : countryDetails.data) == null ? void 0 : _b2.id, name: (_d2 = (_c2 = countryDetails == null ? void 0 : countryDetails.data) == null ? void 0 : _c2.attributes) == null ? void 0 : _d2.name }];
    const defaultValue = formData == null ? void 0 : formData[element.name];
    return /* @__PURE__ */ React.createElement("div", { className: "input", key: `${element.id}-${index}` }, element.nodeName === NODE_NAMES.SELECT ? isStateInput ? ((_e = countryDetails == null ? void 0 : countryDetails.subdivisionsList) == null ? void 0 : _e.length) || isPreview ? renderSelectElement(element, label, isStateInput, previewList) : null : renderSelectElement(element, label, isStateInput, previewList) : isPostalCodeInput && codePattern || isPreview || !isPostalCodeInput ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { htmlFor: label.for }, t(label.nodeValue)), /* @__PURE__ */ React.createElement(
      "input",
      {
        onFocus: (e) => onFocus(e, element),
        type: element.type,
        autoComplete: element.autocomplete,
        id: element.id,
        name: element.name,
        pattern: isPostalCodeInput ? codePattern : null,
        placeholder: t(element.placeholder),
        required: element.required,
        defaultValue
      }
    )) : null);
  }));
};
FormBuilderFormInterfaceAddress.displayName = "FormBuilderFormInterfaceAddress";
export default React.memo(FormBuilderFormInterfaceAddress);
